import Abstract from './abstract';

export default class HeaderAnkerAdView extends Abstract {
  init() {
    this.getElement();
    this.addEvent();
  }

  getElement() {
    this.headerAnkerAd = document.querySelector('.js-header-anker');
    this.ankerAdCloseButton = document.querySelector('.js-header-anker-ad-close-button');
  }

  addEvent() {
    this.ankerAdCloseButton?.addEventListener('click', this.onHide.bind(this));
  }

  onHide() {
    this.headerAnkerAd?.classList?.add('header-AnkerAd--Hidden');
  }
}
